import { useStore } from '../../store/reducers';

/**
 * Determines whether the current user is a child account.
 * @returns {boolean} True if the current user has a parent ID, false otherwise.
 */
export function useIsChildAccount() {
  const user = useStore((s) => s.users.getter.currentUser());
  return user?.parentId !== null;
}
